export const WEEK_DAYS_MON_START = [
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
  '日',
] as const;

export const WEEK_DAYS_SUN_START = [
  '日',
  '一',
  '二',
  '三',
  '四',
  '五',
  '六',
] as const;
